
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import PercentOutlineWidget from "@/components/dashboard/PercentOutlineWidget.vue"
import CircularProgressWidget from "@/components/dashboard/CircularProgressWidget.vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import SuperScoreProgressWidget from "@/components/dashboard/SuperScoreProgressWidget.vue"
import {Prop} from "vue-property-decorator"
import {Dimension, Metric} from "@/cube"

@Component({
  components: {
    Page,
    MetricTrendWidget,
    SuperScoreProgressWidget,
    PercentOutlineWidget,
    CircularProgressWidget,
    ChangeRateWidget,
  },
})
export default class SsComponentPage extends AbstractPage {
  @Prop()
  contactReason: string
  // nominatedBeneficiary accountBalance insurance investment retirementAdequacy

  @Prop()
  contactText: string
  // nominated beneficiaries
  // account balance
  // life insurance
  // investment approach
  // retirement adequacy

  @Prop()
  title: string

  @Prop()
  averageMetric: Metric
  // averageBeneficiaryScore averageAccountBalanceScore averageInsuranceScore
  // averageInvestmentScore averageRetirementAdequacyScore

  @Prop()
  headlineFilter: {[K in Dimension]?: unknown}

  @Prop()
  headlineText: string
  // with no nominated beneficiary
  // with seemingly low account balance
  // with potentially inadequate life insurance
  // with a seemingly unsuitable investment strategy
  // are below the Modest lifestyle benchmark in retirement

  @Prop()
  progressFilter: {[K in Dimension]?: unknown}

  @Prop()
  progressText: string

  @Prop({default: null})
  trendMetric: Metric

  @Prop({default: () => ({})})
  trendFilter: {[K in Dimension]?: unknown}

  @Prop()
  mainChartTitle: string

  titleCase = (title: string) =>
    `${title[0].toUpperCase()}${title.slice(1).toLowerCase()}`

  get contactRequests() {
    return this.metricStore.get(this.$metrics.ContactRequested.countRequests, {
      [this.$cubes.ContactRequestedCube.reason]: this.contactReason,
    })
  }
}
